import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.7125 9.5625H4.12499L9.18749 14.625H7.61249L1.98749 9L7.61249 3.375H9.18749L4.12499 8.4375H15.7125V9.5625Z",
		fill: "currentColor"
	})
});
export default SvgLeftArrow;
